import { Link } from "react-router-dom";
import AnimeCard from "@/components/feature/AnimeCard";
import { animeList, fmtDate } from "@/mocks/anime";

const latest = [...animeList].sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1)).slice(0, 8);

export default function LatestAnime() {
  const today = new Date();
  const weekStart = new Date(today);
  weekStart.setDate(today.getDate() - ((today.getDay() + 6) % 7));

  const schedule = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"].map((day, i) => {
    const date = new Date(weekStart);
    date.setDate(weekStart.getDate() + i);
    return { day, label: fmtDate(date.toISOString().slice(0, 10)) };
  });

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100" aria-labelledby="latest-title">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <p className="text-[11px] font-bold tracking-[0.2em] text-accent-600 mb-2">NEW ARRIVALS</p>
          <h2 id="latest-title" className="text-xl md:text-2xl font-black text-foreground-950 tracking-tight">
            最新上线动漫
          </h2>
          <p className="mt-2 text-[13px] text-foreground-600">按更新时间排列，追新不错过每一话</p>
        </div>
        <Link
          to="/category/guoman"
          className="hidden sm:inline-flex items-center gap-1 text-[13px] font-medium text-primary-700 hover:text-primary-800 transition-colors whitespace-nowrap cursor-pointer"
        >
          查看更多 <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mb-6 flex flex-wrap items-center gap-1.5 md:gap-2">
        {schedule.map((item, i) => (
          <div
            key={item.day}
            className={`flex-1 min-w-[92px] px-2 py-2 rounded-md text-center ${
              today.getDay() === (i + 1) % 7
                ? "bg-primary-900 text-background-50"
                : "bg-background-50 text-foreground-600 border border-background-200"
            }`}
          >
            <p className="text-[11px] font-semibold opacity-80">{item.day}</p>
            <p className="text-[11px] mt-0.5 opacity-70">{item.label}</p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
        {latest.map((anime) => (
          <AnimeCard key={anime.id} anime={anime} />
        ))}
      </div>
    </section>
  );
}